import React from "react";

import MatrimonyHeader from "../components/MatrimonyHeader";
import MatriProfileHero from "../components/MatriProfileHero";
import Profilecard from "../components/Profilecard";
import MatriContent from "../components/MatriContent";
import Footer from "../components/Footer";
import MatriHeader from "../components/MatriHeader";

function MatrimonyProfileDetail() {
  return (
    <div className="min-h-screen flex flex-col">
      <MatriHeader />

      <main className="flex-1">
        <MatriProfileHero />
        <Profilecard />
      </main>

      <Footer />
    </div>
  );
}

export default MatrimonyProfileDetail;
